"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_inlinesvg_1 = require("react-inlinesvg");

var sortUpSvg = require("../../../icons/sortUp-16.svg");

var sortDownSvg = require("../../../icons/sortDown-16.svg");

var styles_1 = require("./styles");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var FullTableHeaderRowSortCell =
/** @class */
function (_super) {
  __extends(FullTableHeaderRowSortCell, _super);

  function FullTableHeaderRowSortCell() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ariaLabelCell = function (hasSortIcon, display) {
      if (hasSortIcon) {
        return "Sort " + display + " in descending order";
      }

      return "Sort " + display + " in ascending order";
    };

    return _this;
  }

  FullTableHeaderRowSortCell.prototype.render = function () {
    var _a = this.props,
        index = _a.index,
        display = _a.display,
        activeSortCell = _a.activeSortCell,
        cellHasSort = _a.cellHasSort,
        performSort = _a.performSort;
    return React.createElement("div", __assign({
      onClick: function onClick() {
        return performSort(index);
      },
      "aria-label": this.ariaLabelCell(cellHasSort, display),
      tabIndex: 1,
      role: "cell",
      className: "cell " + (activeSortCell === index ? styles_1.activeSortCellStyle : '')
    }, styles_1.cellStyle, font_1.regular), display, React.createElement("div", __assign({
      className: "cellSort"
    }, styles_1.cellSortStyle), React.createElement(react_inlinesvg_1.default, {
      src: cellHasSort ? sortDownSvg : sortUpSvg,
      className: "sortStyle " + styles_1.sortStyle
    })));
  };

  return FullTableHeaderRowSortCell;
}(React.Component);

exports.FullTableHeaderRowSortCell = FullTableHeaderRowSortCell;